import React, {
  useState,
  useEffect
} from 'react';

import {
  BaseAPI,
  APIError,
} from './BaseAPI';

class ProfileAPI extends BaseAPI {
  path = 'students/profile/'
}

let profileAPI: ProfileAPI;
function getAPI() {
  if (!profileAPI) profileAPI = new ProfileAPI();
  return profileAPI;
}

function useProfile(path='') {
  const [profile, setProfile] = useState({} as any);
  const [loading, setLoading] = useState(true);

  const loadProfile = async () => {
    setLoading(true);
    const profileAPI = getAPI();
    try {
      const data = await profileAPI.get(path);
      setProfile(data);
    } catch (error) {
      console.error(error);
    }

    setLoading(false);
  }

  const updateProfile = async (data: any) => {
    let success = false;
    setLoading(true);
    const profileAPI = getAPI();
    try {
      const [result, response, error] = await profileAPI.post(data, path);
      if (result && result.success) {
        if (data.password) {
          // changing password will log user out
          // reload so user can re-login
          window.location.reload();
          return [success, result];
        }
  
        const profile = await profileAPI.get(path);
        setProfile(profile);
        success = true;
      }
      setLoading(false);
      return [success, result];
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
    return [success, undefined];
  };

  const updateProfilePicture = async (image: any) => {
    let success = false;
    setLoading(true);
    let formData = new FormData();
    formData.append('picture', image);
    formData.append('full_name', profile.full_name);
    formData.append('sub_program', profile.sub_program);

    const profileAPI = getAPI();
    try {
      const [result, response, error] = await profileAPI.post(formData, path);
      if (result && result.success) {
        const profile = await profileAPI.get(path);
        setProfile(profile);
        success = true;
      }
      setLoading(false);
      return [success, result];
    } catch (error) {
      console.error(error);
      setLoading(false);
    }

    return [success, undefined];
  };

  useEffect(() => {
    loadProfile();
  }, []);

  return [
    profile,
    loading,
    updateProfile,
    updateProfilePicture,
  ];
}

export {
  getAPI,
  useProfile,
};
